import { SaveButton } from "components/Buttons"
import React, { useState } from "react"
import { connect } from "react-redux"
import { Col, FormFeedback, Input, Row } from "reactstrap"
import { cancelBooking, getBookingCalendars } from "store/actions"

const CancelBookingForm = ({
  booking,
  onClose,
  cancelBooking,
  getBookingCalendars,
}) => {
  const [cancelValue, setCancelValue] = useState(1)

  const onCancelBooking = () => {
    cancelBooking({
      values: { booking_id: booking?.id, cancelled_seats: cancelValue },
      callback: () => {
        onClose()
        getBookingCalendars({ type: 2 })
      },
    })
  }

  return (
    <React.Fragment>
      {(booking?.booked_seats > 1 || booking?.cancelled_seats > 0) && (
        <React.Fragment>
          <Row>
            <Col>
              <span>
                <label>Currently booked seats: </label> {booking?.booked_seats}
              </span>
            </Col>
          </Row>
          <Row>
            <Col>
              <span>
                <label>Already cancelled seats: </label>{" "}
                {booking?.cancelled_seats}
              </span>
            </Col>
          </Row>
        </React.Fragment>
      )}
      {booking?.booked_seats == 1 && (
        <Row className="my-2">
          <Col>
            <h6>
              Are you sure you want to cancel this booking?
              <br />
              You cannot undo a cancellation.
            </h6>
          </Col>
        </Row>
      )}
      {booking?.booked_seats > 1 && (
        <Row className="my-2">
          <Col xs="auto" className="align-self-center">
            <label>Seats to cancel:</label>
          </Col>
          <Col xs="3">
            <Input
              value={cancelValue}
              onChange={event => {
                setCancelValue(event.target.value)
              }}
              type="number"
              min="1"
              max={booking?.booked_seats}
              invalid={
                cancelValue > booking?.booked_seats || !cancelValue.toString()
              }
            />
          </Col>
          <FormFeedback>
            <div className="mt-3">
              {!cancelValue
                ? "The seats number is required"
                : `You can't cancel more than ${booking?.booked_seats} seats`}
            </div>
          </FormFeedback>
        </Row>
      )}
      <Row className="d-flex justify-content-center mt-3">
        <Col xs="auto">
          <SaveButton type="button" content="Keep booking" onClick={onClose} />
        </Col>
        <Col xs="auto">
          <SaveButton
            type="button"
            content="Cancel booking"
            color="danger"
            onClick={onCancelBooking}
            disabled={
              cancelValue === 0 ||
              cancelValue > booking?.booked_seats ||
              !cancelValue.toString()
            }
          />
        </Col>
      </Row>
    </React.Fragment>
  )
}

const mapDispatchToProps = dispatch => ({
  cancelBooking: values => dispatch(cancelBooking(values)),
  getBookingCalendars: values => dispatch(getBookingCalendars(values)),
})

export default connect(null, mapDispatchToProps)(CancelBookingForm)
